{
  "fr": {
    "navbar": {
      "customer": {
        "after_care": "Après-vente",
        "dashboard": "Accueil",
        "decisions": "Décisions",
        "documents": "Documents",
        "inspirations": "Inspirations",
        "installments": "Finances",
        "profile": "Votre Profil",
        "projectinfo": "Information",
        "question_lists": "FAQ",
        "surveys": "Formulaires",
        "ticket": {
          "new": "Nouvelle Conversation"
        },
        "tickets": "Conversations",
        "units": "Dossier d'intervention ultérieure"
      },
      "employee": {
        "all_projects": "Projets",
        "client": "Profil {client}",
        "contacts": "Contacts",
        "customer": "Client",
        "dashboard": "Accueil",
        "employee": "Collègue",
        "overview": "Aperçu",
        "partner": "Partenaire",
        "profile": "Votre Profil",
        "project": {
          "after_care": "Après-vente",
          "decisions": "Décisions",
          "documents": "Documents",
          "email_conversations": "E-mails entrants",
          "info": "Information",
          "installments": "Finances",
          "milestones": "Jalons",
          "news": "Actualités",
          "question_lists": "FAQs",
          "sales": "Vente",
          "surveys": "Formulaires",
          "todos": "Tâches",
          "todos_v2": "Tâches v2"
        },
        "projects": "Projets",
        "ticket": {
          "new": "Nouvelle Conversation"
        },
        "tickets": "Conversations"
      },
      "landmarks": {
        "employee": {
          "client": {
            "primary": "Navigation principale",
            "secondary": "Navigation secondaire"
          }
        }
      },
      "partner": {
        "contacts": "Contacts",
        "dashboard": "Accueil",
        "profile": "Votre profile",
        "project": {
          "after_care": "Après-vente",
          "decisions": "Décisions",
          "documents": "Documents",
          "tickets": "Conversations"
        },
        "projects": "Projets"
      },
      "topnavbar": {
        "company": "Entreprise",
        "helpcenter": "Centre d'Aide",
        "inviteManageMembers": "Inviter et gérer les membres",
        "logout": "Déconnexion",
        "profile": "Profil",
        "searchTeam": "Rechercher une entreprise",
        "selectTeam": "Sélectionner entreprise",
        "settings": "Paramètres",
        "team": "Équipe"
      }
    }
  }
}
